export enum LogoWithBackBtnType {
  DEFAULT = 'default',
  DARK = 'dark',
}

export interface LogoWithBackBtnProps {
  onBack: VoidFunction;
  onLogoClick: VoidFunction;
  isMobileLogo?: boolean;
  disableBackButton?: boolean;
  hideBackButton?: boolean;
  logoWithBackBtnType?: LogoWithBackBtnType;
}